import React, { useState } from "react";
import { ProductCard, Search } from "../components/index";

import { category, query } from "../states/atoms/filtration";
import { useRecoilState } from "recoil";
import { sortBy, view } from "../states/atoms/grid";
import { Checkbox } from "primereact/checkbox";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import logo_efaciliti from "../assets/view.svg";
import AllIcon from "../assets/icons/MyIcons/ICONairALL.svg";
import condorBrand from "../assets/brands/condor.svg";
import cristorBrand from "../assets/brands/cristor.svg";
import nardiBrand from "../assets/brands/nardi.svg";
import hisenseBrand from "../assets/brands/hisense.svg";
import { useQuery } from "@tanstack/react-query";
import { allProducts, categoriesList } from "../fetchers/routes";
import { isMobile } from "react-device-detect";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useLocation } from "react-router-dom";

import ReactGA from "react-ga4";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="grid" sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function Products() {
  ReactGA.send({
    hitType: "pageview",
    page: "/products",
    title: "BEA | Products",
  });

  const location = useLocation();
  const initialBrands =
    location.state && location.state["brands"] ? location.state["brands"] : [];

  const [_query, setQuery] = useRecoilState(query);

  const [categoryIndex, setCategoryIndex] = useRecoilState(category);
  const [visibleCategories, setVisibleCategories] = useState(false);
  const [visibleBrands, setVisibleBrands] = useState(false);

  //todo:simulator state "recoil"

  const [brands, setBrands] = useState(initialBrands);
  const [categoriesState, setCategoriesState] = useState([]);
  const [sortByIndex, setSortByIndex] = useRecoilState(sortBy);
  const [viewGrid, setViewGrid] = useRecoilState(view);
  const { t, i18n } = useTranslation();

  //------------------------------------------------------------------------------------------------------------------
  const productdata = useQuery(["products"], allProducts, { staleTime: 3000 });
  //------------------------------------------------------------------------------------------------------------------
  const categoriesdata = useQuery(["categories"], categoriesList, {
    staleTime: 3000,
  });
  //------------------------------------------------------------------------------------------------------------------
  const products = productdata.data;
  const categories = categoriesdata.data;
  const result =
    categoriesState.length < 1
      ? products
      : products.filter((obj) => categoriesState.includes(obj.category.name));
  //------------------------------------------------------------------------------------------------------------------
  if (productdata.isLoading || categoriesdata.isLoading) {
    return <div>Loading...</div>;
  }

  if (productdata.isError || categoriesdata.isError) {
    return <div>Error...</div>;
  }
  //=====================================================================================================================================================================
  // ? ========================================= SEARCH FILTER ==========================================================================================================
  const filteredProducts =
    products &&
    products.filter((product) => {
      const matchesQuery =
        _query.trim() === "" ||
        product.name.toLowerCase().includes(_query.toLowerCase()) ||
        product.description.toLowerCase().includes(_query.toLowerCase()) ||
        product.variantes.some(
          (variante) =>
            variante.name.toLowerCase().includes(_query.toLowerCase()) ||
            variante.namear.toLowerCase().includes(_query.toLowerCase()) ||
            variante.reference.toLowerCase().includes(_query.toLowerCase())
        );

      const matchesCategory =
        categoriesState.length === 0 ||
        categoriesState.includes(product.category.name);

      const matchesBrand =
        brands.length === 0 || brands.includes(product.brand.name);
      return matchesQuery && matchesCategory && matchesBrand;
    });

  //=====================================================================================================================================================================

  const ProductsList = result.filter((hero) => {
    return brands.some((filter) => {
      return filter === hero.brand.name;
    });
  });
  //------------------------------------------------------------------------------------------------------------------
  const removeProductsWithNoVariants = (products) => {
    return products.filter(
      (product) => product.variantes && product.variantes.length > 0
    );
  };

  const sortProducts = (sortedProducts, index) => {
    // Uncomment the line below if you want to return products without sorting for invalid index values
    // if (index < 0 || index > 4) return products;
    sortedProducts = removeProductsWithNoVariants(sortedProducts);
    sortedProducts
      .sort((a, b) => a.priority - b.priority)
      .sort((a, b) => a.category.priority - b.category.priority)
      .reverse();

    switch (index) {
      case 0: // Sort by price ascending
        sortedProducts.sort(
          (a, b) => a.variantes[0].price - b.variantes[0].price
        );
        break;
      case 1: // Sort by price descending
        sortedProducts.sort(
          (a, b) => b.variantes[0].price - a.variantes[0].price
        );
        break;
      case 2: // Sort by name ascending
        sortedProducts.sort((a, b) => {
          const aName = a.name.toLowerCase().trim();
          const bName = b.name.toLowerCase().trim();
          if (aName < bName) return -1;
          if (aName > bName) return 1;
          return 0;
        });
        break;
      case 3: // Sort by name descending
        products.sort((a, b) => {
          const aName = a.name.toLowerCase().trim();
          const bName = b.name.toLowerCase().trim();
          if (aName < bName) return 1;
          if (aName > bName) return -1;
          return 0;
        });
        break;
      default: // Sort by priority, then by category priority, both in descending order
        sortedProducts.sort((a, b) => {
          const categoryPriorityDiff =
            b.category.priority - a.category.priority;
          if (categoryPriorityDiff !== 0) return categoryPriorityDiff;
          return b.priority - a.priority;
        });
        break;
    }
    return sortedProducts;
  };

  //------------------------------------------------------------------------------------------------------------------
  const onBrandsChange = (e) => {
    let _brands = [...brands];

    if (e.checked) _brands.push(e.value);
    else _brands.splice(_brands.indexOf(e.value), 1);
    setBrands(_brands);
  };
  //------------------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------------------
  const onCategoryChange = (e) => {
    let _categories = [...categoriesState];

    if (e.checked) _categories.push(e.value);
    else _categories.splice(_categories.indexOf(e.value), 1);

    setCategoriesState(_categories);
  };
  //------------------------------------------------------------------------------------------------------------------
  const onCategoryChangeAll = (e) => {
    setCategoriesState([]);
  };

  return (
    <>
      <Search />
      <section className="w-screen">
        <div
          className={`mx-auto md:w-11/12 py-10 flex flex-col gap-4 ${
            i18n.language === "fr" ? "md:flex-row" : "md:flex-row-reverse"
          }`}
        >
          {isMobile ? (
            <></>
          ) : (
            <section id="filters" className="w-full md:w-1/6">
              <div className="filters-side-bar sticky top-10 w-full-important flex flex-col mr-2 ">
                <div className="flex flex-row items-center ">
                  <img alt="..." className="w-10" src={logo_efaciliti} />
                  <p className="font-bold text-xl">{t("products.marques")}</p>
                </div>
                <div className="flex flex-row place-self-center md:flex-col">
                  <label className="flex flex-row ml-8 m-4">
                    <Checkbox
                      inputId="CondorBrand"
                      name="condor"
                      value="Condor"
                      onChange={onBrandsChange}
                      checked={brands.includes("Condor")}
                    />
                    <img
                      className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                      src={condorBrand}
                      alt="..."
                    />
                  </label>
                  <label className="flex flex-row ml-8 m-4">
                    <Checkbox
                      inputId="CristorBrand"
                      name="cristor"
                      value="Cristor"
                      onChange={onBrandsChange}
                      checked={brands.includes("Cristor")}
                    />
                    <img
                      className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                      src={cristorBrand}
                      alt="..."
                    />
                  </label>
                  <label className="flex flex-row ml-8 m-4">
                    <Checkbox
                      inputId="CristorBrand"
                      name="cristor"
                      value="Nardi"
                      onChange={onBrandsChange}
                      checked={brands.includes("Nardi")}
                    />
                    <img
                      className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                      src={nardiBrand}
                      alt="..."
                    />
                  </label>
                  <label className="flex flex-row ml-8 m-4">
                    <Checkbox
                      inputId="HisenseBrand"
                      name="hisense"
                      value="Hisense"
                      onChange={onBrandsChange}
                      checked={brands.includes("Hisense")}
                    />
                    <img
                      className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                      src={hisenseBrand}
                      alt="..."
                    />
                  </label>
                </div>

                <div className="flex flex-row items-center ">
                  <img className="w-10" src={logo_efaciliti} />
                  <p className="font-bold text-xl">
                    {t("products.categories")}
                  </p>
                </div>
                <div className="flex flex-row place-self-start md:flex-col">
                  <div
                    className="flex flex-row place-items-center ml-6 m-2 cursor-pointer"
                    onClick={onCategoryChangeAll}
                  >
                    <img className="w-1/4" alt={"..."} src={AllIcon} />
                    <span className="text-black text-lg font-bold ">Tous</span>
                  </div>
                  {categories
                    ?.sort((a, b) => a.priority - b.priority)
                    .reverse()
                    .map((category, i) => (
                      <label className="flex flex-row ml-8 m-4" key={i}>
                        <Checkbox
                          inputId="CondorBrand"
                          className="mr-2"
                          name="category"
                          value={category.name}
                          onChange={onCategoryChange}
                          checked={categoriesState?.includes(
                            `${category.name}`
                          )}
                        />
                        <span className="text-gray-700">
                          {" "}
                          {i18n.language === "fr"
                            ? category.name
                            : category.namear}
                        </span>
                      </label>
                    ))}
                </div>
              </div>
            </section>
          )}

          <section id="products" className="px-4 md:w-full">
            <article
              id="list-header"
              className="flex flex-col md:grid md:items-center gap-y-2 md:gap-x-6 "
            >
              {isMobile ? (
                <div className="flex flex-col justify-between">
                  <div className="pb-4 flex justify-around">
                    <Button
                      className="bg-primary-color p-2"
                      onClick={() => setVisibleCategories(true)}
                    >
                      <img className="h-8 sm:h-12" src={logo_efaciliti} />
                      <p className="font-bold text-xs sm:text-base">
                        {t("products.categories")}
                      </p>
                    </Button>

                    <Dialog
                      header="Categories"
                      headerClassName="text-center"
                      visible={visibleCategories}
                      onHide={() => setVisibleCategories(false)}
                      style={{ width: "50vw" }}
                      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                    >
                      <div className="flex flex-col place-self-start">
                        {categories
                          ?.sort((a, b) => a.priority - b.priority)
                          .reverse()
                          .map((category, i) => (
                            <label className="flex flex-row ml-8 m-4" key={i}>
                              <Checkbox
                                inputId="CondorBrand"
                                className="mr-2"
                                name="category"
                                value={category.name}
                                onChange={onCategoryChange}
                                checked={categoriesState?.includes(
                                  `${category.name}`
                                )}
                              />
                              <span className="text-gray-700">
                                {" "}
                                {i18n.language === "fr"
                                  ? category.name
                                  : category.namear}
                              </span>
                            </label>
                          ))}
                      </div>
                    </Dialog>

                    <Button
                      className="bg-primary-color p-2"
                      onClick={() => setVisibleBrands(true)}
                    >
                      <img
                        alt="..."
                        className="h-8 sm:h-12"
                        src={logo_efaciliti}
                      />
                      <p className="font-bold text-xs sm:text-base">
                        {t("products.marques")}
                      </p>
                    </Button>

                    <Dialog
                      header="Brands"
                      headerClassName="text-center"
                      visible={visibleBrands}
                      onHide={() => setVisibleBrands(false)}
                      style={{ width: "50vw" }}
                      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                    >
                      <div className="flex flex-col text-center place-self-center">
                        <label className="flex flex-row ml-8 m-4">
                          <Checkbox
                            inputId="CondorBrand"
                            name="condor"
                            value="Condor"
                            onChange={onBrandsChange}
                            checked={brands.includes("Condor")}
                          />
                          <img
                            className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                            src={condorBrand}
                            alt="..."
                          />
                        </label>
                        <label className="flex flex-row ml-8 m-4">
                          <Checkbox
                            inputId="CristorBrand"
                            name="cristor"
                            value="Cristor"
                            onChange={onBrandsChange}
                            checked={brands.includes("Cristor")}
                          />
                          <img
                            className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                            src={cristorBrand}
                            alt="..."
                          />
                        </label>
                        <label className="flex flex-row ml-8 m-4">
                          <Checkbox
                            inputId="CristorBrand"
                            name="cristor"
                            value="Nardi"
                            onChange={onBrandsChange}
                            checked={brands.includes("Nardi")}
                          />
                          <img
                            className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                            src={nardiBrand}
                            alt="..."
                          />
                        </label>
                        <label className="flex flex-row ml-8 m-4">
                          <Checkbox
                            inputId="HisenseBrand"
                            name="hisense"
                            value="Hisense"
                            onChange={onBrandsChange}
                            checked={brands.includes("Hisense")}
                          />
                          <img
                            className="w-1/3 ml-2 sm:w-10/12 lg:w-1/2"
                            src={hisenseBrand}
                            alt="..."
                          />
                        </label>
                      </div>
                    </Dialog>
                  </div>
                </div>
              ) : (
                <div
                  className={`btn-container ${
                    i18n.language === "ar" ? "flex-row-reverse" : ""
                  }`}
                >
                  <button
                    className={`border border-primary-color rounded w-6 md:w-7 p-1 transition duration-500 ${
                      viewGrid
                        ? "bg-primary-color text-white"
                        : "text-primary-color"
                    }`}
                    onClick={() => setViewGrid(true)}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 2.5A1.5 1.5 0 012.5 1h3A1.5 1.5 0 017 2.5v3A1.5 1.5 0 015.5 7h-3A1.5 1.5 0 011 5.5v-3zm8 0A1.5 1.5 0 0110.5 1h3A1.5 1.5 0 0115 2.5v3A1.5 1.5 0 0113.5 7h-3A1.5 1.5 0 019 5.5v-3zm-8 8A1.5 1.5 0 012.5 9h3A1.5 1.5 0 017 10.5v3A1.5 1.5 0 015.5 15h-3A1.5 1.5 0 011 13.5v-3zm8 0A1.5 1.5 0 0110.5 9h3a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-3A1.5 1.5 0 019 13.5v-3z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  <button
                    className={`border border-primary-color rounded w-6 md:w-7 p-1 transition duration-500 ${
                      !viewGrid
                        ? "bg-primary-color text-white"
                        : "text-primary-color"
                    }`}
                    onClick={() => setViewGrid(false)}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M2.5 11.5A.5.5 0 013 11h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4A.5.5 0 013 7h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5zm0-4A.5.5 0 013 3h10a.5.5 0 010 1H3a.5.5 0 01-.5-.5z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </button>
                </div>
              )}
              <div
                className={`flex ${
                  i18n.language === "ar" ? "flex-row-reverse" : ""
                }`}
              >
                <p>
                  {filteredProducts && filteredProducts.length}{" "}
                  {t("products.produitsTrouver")}
                </p>
              </div>
              <hr />
              <div
                className={`flex ${
                  i18n.language === "ar" ? "flex-row-reverse" : ""
                }`}
              >
                <form>
                  {/* TODO: PRICE & NAME SORTING */}
                  {/* FIXME:  PRICE & NAME FILTER */}
                  <label>{t("products.filterBy")}</label>
                  <select
                    className="px-4 py-1"
                    value={sortByIndex}
                    onChange={(e) => setSortByIndex(parseInt(e.target.value))}
                  >
                    <option value={-1}>{t("products.default")}</option>
                    <option value={0}>{t("products.priceUp")}</option>
                    <option value={1}>{t("products.priceDown")}</option>
                    <option value={2}>{t("products.nameUp")}</option>
                    <option value={3}>{t("products.nameDown")}</option>
                  </select>
                </form>
              </div>
            </article>
            <article id="products-list">
              <div
                className={`mt-6 ${
                  viewGrid
                    ? "grid gap-4 sm:grid-cols-2 md:gap-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-4"
                    : ""
                }`}
              >
                {sortProducts(filteredProducts, sortByIndex).map((product) => (
                  <ProductCard
                    key={product.id}
                    {...product}
                    grid={viewGrid}
                    local={i18n.language}
                  />
                ))}
              </div>
            </article>
          </section>
        </div>
      </section>
    </>
  );
}
